// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"AddUsers_Tabs__1veYa","Tabs__Item":"AddUsers_Tabs__Item___jvjp","Tabs__Item__Active":"AddUsers_Tabs__Item__Active__1AAqa"};